// <TimeAgo> — renders a relative timestamp ("2m ago", "3h ago", …) with a
// hover tooltip showing the full locale datetime. Use anywhere the old
// bare {timeAgo(x)} pattern appeared so mobile users can long-press and
// desktop users can hover to see the exact time.
import { timeAgo } from "@/lib/format";

interface TimeAgoProps {
  iso: string | null | undefined;
  /** Extra fallback text when iso is null/undefined. Default: "-". */
  fallback?: string;
  /** Additional className passed through to the wrapping span. */
  className?: string;
}

/** Formats an ISO string to the user's locale datetime, falling back to the
 *  raw string if Date parsing fails. */
function formatFullDateTime(iso: string): string {
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleString(undefined, {
      year: "numeric", month: "2-digit", day: "2-digit",
      hour: "2-digit", minute: "2-digit", second: "2-digit",
    });
  } catch { return iso; }
}

export default function TimeAgo({ iso, fallback = "-", className }: TimeAgoProps) {
  if (!iso) return <span className={className}>{fallback}</span>;
  return (
    <span className={className} title={formatFullDateTime(iso)}>
      {timeAgo(iso)}
    </span>
  );
}
